export default {
  login: {
    login: "登入",
    email: "電郵地址",
    mobile: "手機號碼",
    mobile2: "手機號碼",
    password: "密碼",
    errMsg1: "請輸入有效電子郵件",
    errMsg2: "請輸入有效手機號碼",
    errMsg3: "您的帳戶不在此地區",
    errMsg4: "您的用戶名或密碼不正確",
    errMsg5: "您的輸入手機號碼或密碼不正確",
    errMsg6: "由於未收到付款，您的註冊尚未完成。請重新提交註冊表格並完成付款。",
    forgotpw: "忘記密碼",
    register: "註 冊",
    txt: "還不是御宝會員？查看",
    txt_2: "會員禮遇",
  },
  header: {
    home: "首頁",
    eStore: "網店",
    PRivileges: "會員禮遇",
    register: "註冊",
    highlights: "亮點",
    faq: "常見問題",
    mobileApp: "手機應用程式",
    tnp: "條款和隱私",
    friendReferral: "朋友推薦",
    profile: "會員檔案",
  },
  footer: {
    aboutUs: "關於御宝",
    eStore: "網店",
    faq: "常見問題",
    tnp: "條款與隱私",
    pr: "參與分店",
    profile: "會員檔案",
    contactUs: "聯絡我們",
    copyright: "2026©御宝飲食集團版權所有",
  },
  signUp: {
    signUp: "會員註冊",
    title: "註冊御宝忠誠計劃會員",
    mustFill: "“*” 必填字段",
    step1: "帳戶資料",
    step2: "安全資訊",
    step3: "資訊訂閱",
    step4: "推薦人",
    salutation: "稱謂",
    salutation_opt1: "請選擇您的稱謂",
    salutation_opt2: "先生",
    salutation_opt3: "太太",
    salutation_opt4: "女士",
    salutation_opt5: "小姐",
    salutation_opt6: "博士",
    salutation_errMsg: "請選擇稱謂",
    firstname: "名字",
    firstname_errMsg: "請輸入您的名字",
    lastname: "姓氏",
    lastname_errMsg: "請輸入您的姓氏",
    birth: "出生日期",
    birth_errMsg: "請選擇出生日期",
    birth_errMsg2: "您必須年滿18歲",
    mobile: "手機號碼",
    mobile_errMsg: "請輸入有效手機號碼",
    mobile_errMsg2: "手機號碼已註冊",
    emailAddress: "電郵地址",
    emailAddress_errMsg: "請輸入有效電子郵件信箱",
    emailAddress_errMsg2: "電郵地址已註冊",
    confirmEmailAddress: "電郵地址確認",
    confirmEmailAddress_errMsg: "請確認電郵地址",
    gender: "性別",
    gender_opt1: "請選擇您的性別",
    gender_opt2: "男",
    gender_opt3: "女",
    gender_errMsg: "請選擇性別",
    language_preference: "語言選項",
    language_preference_opt1: "請選擇您的語言選項",
    language_preference_opt2: "English",
    language_preference_opt3: "日本語",
    language_preference_opt4: "中文",
    language_preference_errMsg: "請選擇語言選項",
    password_format: "密碼至少為8個字符，其中需包含大小字母、數字和一個特殊字符 (?!@$%&*)",
    password: "*密碼",
    password_errMsg: "請輸入密碼",
    confirm_password: "*密碼確認",
    confirm_password_errMsg: "請再次輸入密碼",
    step3_consent_opt: "我同意以下所有列出的<link>條款和條件<link>",
    step3_consent_opt_1: "我同意列出的<link>條款和條件<link>",
    step3_consent_opt_2: "我同意收集和使用我的個人信息",
    step3_consent_opt_3: "我同意出於行銷目的收集和使用我的個人信息",
    step3_consent_opt_4: "我同意將我的個人資訊傳輸給日本或海外的第三方",
    tnc_errMsg: "Please agree to Terms & Conditions to proceed",
    tnc_errMsg: "請接受條款和條件以繼續下一步",
    step3_title: "點擊下方按鈕，即表示您同意御宝、我司關聯方、相關實體以及代表我司行事的第三方（「業務合作夥伴」）可收集、使用及揭露您在會員入口網站上提供的個人資訊。我司將向您提供由您同意接收的促銷、特別優惠，促銷、特別優惠可能由我司的業務合作夥伴直接發送，我司可能會向我司的業務合作夥伴提供您的個人資訊。",
    step3_q: "我同意接收来自御宝的营销信息（可选）",
    step3_q_opt1: "透過電郵地址",
    step3_q_opt2: "透過電話",
    step4_q_err: "請選擇如何得知御宝忠誠計劃",
    step4_q: "您是如何得知御宝忠誠計劃？",
    step4_q_opt1: "請選擇",
    step4_q_opt2: "東京都中央區銀座, 御宝軒",
    step4_q_opt3: "濱海灣金沙, 御宝軒",
    step4_q_opt4: "百利宮, 御宝至尊烤鴨店",
    step4_q_opt5: "亞洲廣場, 御宝至尊烤鴨店",
    step4_q_opt6: "愛雍·烏節, 御宝閣潮州酒家​",
    step4_q_opt7: "濱海灣金沙, 御宝閣潮州酒家​",
    step4_q_opt8: "高島屋購物中心, 禦園​",
    step4_q_opt9: "大世界, 御宝軒",
    step4_q_opt10: "大世界, 御宝火鍋店",
    step4_q_opt11: "愛雍·烏節, 御宝火鍋店",
    step4_q_opt12: "111 索美賽, 御宝火鍋店",
    step4_q_opt13: "百利宮, 寶一點心",
    step4_q_opt14: "百匯廣場, 寶一點心",
    step4_q_opt15: "來福士城, 寶一點心",
    step4_q_opt16: "口碑介紹",
    step4_q_opt17: "社交媒體",
    step4_q_opt18: "其他",
    step4_q_opt19: "星耀樟宜，御宝至尊烤鴨店",
    step4_q_opt20: "星耀樟宜，寶一點心",
    step4_q_opt21: "愛雍·烏節, 御宝淮揚料理",
    promo_code: "優惠碼",
    promo_code_input_msg: "請輸入有效的促銷代碼（如有）",
    promo_code_err_msg: "請輸入有效的促銷代碼",
    promo_code_re_msg: "促銷代碼有效!",
    total: "總共：",
    refresh: "刷新",
    captcha: "驗證碼",
    captcha_errMsg: "驗證碼不正確",
    cancel: "取消",
    next: "下一步",
    back: "上一步",
    submitForm: "立即付款",
    overtime: "由於您未能在規定的20分鐘內完成註冊，當前頁面已過期。頁面將自動重新整理，請重新開始註冊流程。",
    time_remaining: "剩餘時間",
    time_note: "溫馨提示：您有 20 分鐘完成註冊。請勿重新整理或關閉瀏覽器，直到付款確認完成。"
  },
  aboutUs: {
    aboutUs: "關於御宝",
    txt1: "御宝飲食集團",
    txt2: "御宝飲食集團自2004年開設首家餐廳以來，秉承著追求卓越服務品質的理念，以及匠心打造的精緻正宗中式菜餚，受到業內人士及食客們的肯定。",
    txt3: "集團總部位於新加坡，目前在新加坡、上海、廣州、香港、仁川、日本、倫敦和巴黎開設超過20家餐廳。",
    txt4: "集團旗下的餐廳涵蓋多種菜系，包括粵菜、上海菜、潮州菜、淮揚菜、燒烤、火鍋和點心，並持續擴大其規模 ，為食客帶來更多的餐飲選擇。",
    txt5: "集團獲得超過50項知名獎項，包括米其林指南、亞洲50家最佳餐廳、由美團發佈的黑珍珠餐廳指南和由莊布忠評選的100全球最佳中餐廳，進一步鞏固其高端餐飲領域的優勢地位。",
  },
  faqs: {
    faqs: "須知",
    general: "常見問題",
    general_1: "什麼是御宝獎勵計劃？",
    general_1_1: "御宝獎勵計劃是一個顯忠誠項目，無論什麼時候，只要在本地或海外參與的御宝餐廳用餐，會員便可以享受獨家優惠和酬賓活動。",
    general_2: "如何成為御宝忠誠計劃會員？",
    general_2_1: "您可以在<link>members.imperialtreasure.co.jp<link> 線上註冊。或者，您也可以在任何參與的御宝餐廳註冊。",
    general_3: "在日本有哪些參與的餐廳？",
    general_3_txt: "參與的國內餐廳:",
    general_3_1_txt: "御宝軒",
    general_3_1_1_txt: "東京都中央區銀座 3-5-4 GAREN 大樓 12 樓 104-0061 | 電話：03-6228-6848",

    general_3_1: "Imperial Treasure Bar + Grill",
    general_3_1_1: "大世界, #02-111 | 電話：(+65) 6733 2292",
    general_3_2: "御宝軒 Imperial Treasure Fine Chinese Cuisine",
    general_3_2_1: "濱海灣金沙, 2 樓用餐區, #02-04 | 電話：(+65) 6688 7788",
    general_3_3: "御宝至尊烤鴨店 Imperial Treasure Super Peking Duck",
    general_3_3_1: "百利宮, ＃05-42 | 電話：(+65) 6732 7838",
    general_3_3_2: "亞洲廣場 1座, #02-08 | 電話：(+65) 6636 1868",
    general_3_3_3: "星耀樟宜, #01-219 | 電話：(+65) 6908 6689",
    general_3_4: "御宝閣潮州酒家 Imperial Treasure Fine Teochew Cuisine",
    general_3_4_1: "愛雍·烏節, ＃03-05 | 電話：(+65) 6736 2118",
    general_3_4_2: "濱海灣金沙, 海灣層, #01-26 | 電話：(+65) 6688 7333",
    general_3_5: "禦園 Imperial Treasure Fine Shanghai Cuisine",
    general_3_5_1: "高島屋購物中心, ＃04-22 | 電話：(+65) 6836 6909",
    general_3_6: "御宝軒 Imperial Treasure Cantonese Cuisine ",
    general_3_6_1: "大世界, #02-111 | 電話：(+65) 6732 2232",
    general_3_7: "御宝火鍋店 Imperial Treasure Steamboat Restaurant",
    general_3_7_1: "愛雍·烏節, #04-12A | 電話：(+65) 6636 9339",
    general_3_7_2: "大世界, #01-140 | 電話：(+65) 6235 6008",
    general_3_7_3: "111 索美賽, #02-14 | 電話：(+65) 6235 3882",
    general_3_8: "寶 一點心 Treasures Yi Dian Xin",
    general_3_8_1: "百利宮, #B1-08 | 電話：(+65) 6262 3662",
    general_3_8_2: "Parkway Parade, #02-14 | 電話：(+65) 6247 9218",
    general_3_8_3: "來福士城, #B1-37 | 電話：(+65) 6262 1662",
    general_3_8_4: "星耀樟宜, #01-221 | 電話：(+65) 6908 3668",
    general_3_9: "（*御宝飲食集團保留更改參與餐館的權利，恕不另行通知。）",
    general_3_10: "御宝淮揚料理 Imperial Treasure Huaiyang Cuisine",
    general_3_10_1: "愛雍·烏節, #04-12A | 電話 : (+65) 6636 9339",

    general_4: "在海外有哪些參與的餐廳？",
    general_4_1: "參與的海外餐廳:",
    general_4_1_1: "新加坡 | 上海 | 廣州 | 香港 | 仁川 | 倫敦 | 巴黎:",
    general_4_1_1_sg: "新加坡",
    general_4_1_1_sh: "上海",
    general_4_1_1_gz: "廣州",
    general_4_1_1_hk: "香港",
    general_4_1_1_ic: "仁川",
    general_4_1_1_ld: "倫敦",
    general_4_1_1_pr: "巴黎",
    general_5: "會員的有效期限是多久？",
    general_5_1: "會員有效期限為註冊月份起的1年內。例如：如果註冊於2025年1月18日，則會員資格將於2026年1月17日到期。",
    general_6: "在哪裡可以檢查我的會員到期日？",
    general_6_1: "您可以登入會員專屬網頁以檢查會員資格的到期日。",
    general_7: "申請成為會員的最低年齡是多少？",
    general_7_1: "顧客需年滿18歲才能申請成為會員。",
    general_8: "為什麼須要註冊我的個人資料？",
    general_8_1: "請在<link>members.imperialtreasure.com.jp<link> 註冊您的個人資訊以啟用您的帳戶。此外，還可以接收有關會員即將推出的促銷、獎勵、活動邀請等的最新資訊！",
    general_9: "如何更新我的個人資料？",
    general_9_1: "更新或查看您的個人資料，請透過會員入口網<link>members.imperialtreasure.co.jp<link> 登入您的帳戶，並點擊「個人資料」。如需協助更新您的出生日期，請寄信至 <link>jp.club@imperialtreasure.com<link>。",
    general_10: "如何檢查我的積分，電子禮券和其它獎勵？",
    general_10_1: "您可以登入<link>members.imperialtreasure.co.jp<link>查看您的會員優惠和積分餘額。",
    general_11: "如果我忘了密碼怎麼辦？",
    general_11_1: "要重設密碼，請登入<link>members.imperialtreasure.co.jp<link>並點擊“忘記密碼”，並按照螢幕上的指示重設密碼。",
    general_12: "如果有關於我的會員帳戶的疑問，該怎麼辦？",
    general_12_1: "如果您對您的會員帳戶有任何疑問，請發送電郵地址至 <link>jp.club@imperialtreasure.com<link>。",
    general_13: "會員資格是否可以轉讓？",
    general_13_1: "會員資格不可轉讓。",
    general_14: "如何終止我的會員資格？",
    general_14_1: "會員可以選擇在失效日期之前的任何時間透過書信電郵至 <link>jp.club@imperialtreasure.com<link> 與我們聯繫以終止其會員資格。請注意，終止時將不會退款和/或提前發放任何未使用的電子禮券。另一種方式是讓您的會員資格自動失效，所有積分和/或未使用的電子禮券將被視為放棄使用。",

    tier: "會員等級",
    tier_1: "會員等級有哪些？",
    tier_1_1: "會員等級分為三種：銀，金和鑽石。",
    tier_2: "如何成為銀，金或鑽石會員？",
    tier_2_1: "受邀顧客在網上註冊後，即成為銀會員。",
    tier_2_2: "在會員有效期限內累積消費達¥130萬日元*或以上，即自動成為金會員。",
    tier_2_3: "在會員有效期限內累積消費達¥330萬日圓*或以上，即自動成為鑽石會員。",
    tier_2_4: "*不含服務費，消費稅，電子禮券兌換，購買或使用御宝禮券和季節食品。",

    tier_3: "如何保留我的會員資格？",
    tier_3_1: "要維持金會員資格，只需在會員效期內累積有效消費達¥130萬日元*或以上，即可續保會員資格。",
    tier_3_2: "若要維持鑽石會員資格，只需在會員有效期限內累積有效消費¥330萬日元*或以上，即可續保會員資格。",
    tier_3_3: "*不含服務費，消費稅，電子禮券兌換，購買或使用御宝禮券和季節食品。",

    membership: "會員優惠和獎勵",
    membership_2: "會員優惠有哪些？",
    membership_2_1_1: "贈送禮品",
    membership_2_1_2: "銀",
    membership_2_1_3: "金",
    membership_2_1_4: "鑽石",

    membership_2_2_1: "1 隻北京式烤鴨 ",
    membership_2_2_2: "-",
    membership_2_2_3: "享有",
    membership_2_2_4: "-",

    membership_2_3_1: "1 瓶酒",
    membership_2_3_2: "-",
    membership_2_3_3: "享有",
    membership_2_3_4: "-",

    membership_2_5_1: "1 瓶香檳 ",
    membership_2_5_2: "-",
    membership_2_5_3: "-",
    membership_2_5_4: "享有",

    membership_2_6_1: "1 張5萬円的電子禮券",
    membership_2_6_2: "-",
    membership_2_6_3: "-",
    membership_2_6_4: "享有",

    membership_3: "如何知道我的會員優惠是否到期？",
    membership_3_1: "若要檢查各項優惠的到期日期，只需登入會員專屬網頁<link>members.imperialtreasure.co.jp<link> 並查看「禮券」部分的詳細資訊。",

    membership_6: "如何證明自己是會員？",
    membership_6_1: "只需在參與餐廳用餐時，向我們的服務人員提供您的手機號碼便可。",

    membership_7: "如何領取送禮禮品？",
    membership_7_1: "食品/酒類可以在御宝軒領取，需要提前一天預訂。兌換現金禮券，請在付款前通知服務人員。會員必須親在場（需提供身分證明）才能兌換任何會員特權。",

    membership_8: "作為企業客戶，公司折扣能不能與會員優惠並用？",
    membership_8_1: "不可以。公司折扣不能與會員優惠一起使用。企業客戶只能在公司折扣或會員優惠二者選其一。",

    membership_9: "會員能不能在海外的御宝餐廳享有優惠？",
    membership_9_1: "i$可在所有御宝餐廳賺取，包括國內外分店。 i$的兌換將根據您註冊的本國以及御宝設定的匯率進行。至於代金券兌換，您只能在您的帳戶註冊所在國家進行兌換。",
    membership_10: "會員資格是否可以轉讓？",
    membership_10_1: "會員資格不可轉讓。",

    point: "賺取與兌換積分",
    point1: "",
    point_2: "如何賺取i-dollar（i $）？",
    point_2_1: "無論國內或海外，每消費1,000円*，即可賺取 i$1。",
    point_2_1_1: "會員必須在場並交付帳單以賺取i $。 i$賺取必須在買單時積分賺取。之前或回溯收據一律不被接受積分賺取。一旦會員資格到期， i$ 也將過期。未使用的 i$ 將享有3個月的寬限期。會員必須在寬限期成功轉換為電子禮券，任何未使用的 i$ 將被作廢。 \n*不包括促銷品，服務費，消費稅, 電子禮券兌換，購買或使用御宝餐券和季節產品。",
    point_3: "如何使用積分？",
    point_3_1: "每賺取 i$50，會員將自動收到 ¥5,000*的電子禮券（只限會員有效期限內使用）。 會員可在任何參與餐廳用餐時使用電子禮券抵扣帳單。會員必須在場並交付帳單以兌換會員優惠。",
    point_3_1_1: "(*系統每天在規定的時間內自動轉換積分餘額）",
    point_4: "可以在電子商店線上購物賺取和使用積分或電子禮券嗎？",
    point_4_1: "不能，除非另有規定。",
    point_5: "我的i-dollar (i$) 會過期嗎？",
    point_5_1: "會的。 i-dollar（i $）只在會員期間有效，一旦會員資格到期，i-dollar（i $）也將過期。未使用的i-dollar（i $）將享有3個月的寬限期。會員必須在寬限期成功轉換為電子禮券，任何未使用的i-dollar將被作廢。",
    point_6: "每次消費後，我的i-dollar會立即顯示出來嗎？",
    point_6_1: "會的。系統將即時顯示賺取的i-dollar。除非在網路延遲導致的情況下，請允許些時段讓系統顯示所賺取的i-dollar。",
    point_7: "可以使用多個會員帳戶賺取和兌換 i$ 嗎？",
    point_7_1: "不。您不得合併多個會員帳戶來賺取 i$ 或利用會員福利。",
    point_8: "我可以分攤我的帳單來賺取 i$ 和/或兌換會員特權嗎？",
    point_8_1: "不。您不能透過分攤帳單來賺取 i$ 或利用會員福利。",
    point_9: "如果我不在場，我的家人或朋友可以使用我的會員優惠賺取或兌換i-dollar嗎？",
    point_9_1: "不。會員權益必須由會員本人使用。",
    point_10: "透過第三方平台進行的線上訂單我可以賺取 i$ 或兌換會員特權嗎？",
    point_10_1: "不。透過第三方平台下的線上訂單不符合賺取 i-Dollars 或享受會員權益。",

    renewal: "會員續費",
    renewal_1: "如何為我的會員資格續費？",
    renewal_1_1: "會員續費可以通過會員專屬網頁members.imperialtreasure.com 也可以在任何參與餐館完成會員資格續費。",
    renewal_2: "會員資格續費是多少？",
    renewal_2_1: "續費為S$38。",
    renewal_3: "如何為我的金/鑽石會員資格續費？",
    renewal_3_1: "只需在會員年份內累積有效消費達S$10,888*或以上（金級會員）或S$28,888*或以上（鑽石級會員），即可在有效期後自動續保會員資格。",
    renewal_4: "續費成為會員可以享受什麼優惠？",
    renewal_4_1: "會員將在新的會員有效期收到一張S$50的續期電子禮券（有效期為會員更新身份的3個月內), 1 X S$100 生日電子禮券 (適用于單筆消費滿S$280或以上,只限生日月份使用）和 3 X S$30火鍋湯底電子禮券(有效期12個月)。",
    renewal_5: "可以在會員資格有效日期前續會員資格嗎？",
    renewal_5_1: "可以。您可以在到期前1個月內續訂會員資格，新會員資格週期將從原來的有效期日開始計算。",

  },
  tnc: {
    title: "條款和隱私",
    membership: "會員條款和隱私",
    membership_1_1: "1.1 Introduction",
    membership_1_1_1: 'Imperial Treasure Restaurant Group Pte Ltd (“Imperial Treasure”) would like to offer our privileged customers news and information regarding our products and services, including promotions, special offers and discounts. We are offering you the opportunity to become a member of the Imperial Treasure Club (a "Member") to enjoy special privileges that Imperial Treasure may offer from time to time.',
    membership_1_2: "1.2 Collection and use of personal data",
    membership_1_2_1: "If you become a Member, you will need to provide Imperial Treasure with certain personal information (including your name and contact details such as email address and phone number). You will need to provide us with your mobile number for us to identify you. Your mobile number will be your username or unique identifier as a Member. Any personal data held by us about you will be held in accordance with our Privacy Notice.",
    membership_1_3: "1.3 Membership Tiers",
    membership_1_3_1: "1.3.1 Membership registration, i-dollars, and e-vouchers",
    membership_1_3_1_1: "Where you sign-up to become a Member, you will be required to provide your mobile number, among other information we may require from you, in order to sign up for the membership. This may be required online or by our restaurant staff depending on the circumstances.",
    membership_1_3_1_2: "Membership is strictly non-transferable and shall only be enjoyed by the Member in person.",
    membership_1_3_1_3: "As a Member, you earn one (01) i-dollar at the rate specified on the membership programme website [https://members.imperialtreasure.co.jp] for the country in which you signed up, when you spend at any participating Imperial Treasure restaurants (excluding service charge, GST/VAT, e-vouchers used, and the purchase and use of Imperial Treasure gift vouchers). Please refer to the Member’s Portal for a list of participating Imperial Treasure restaurants. Member must be physically present at the point of dining and provide the registered mobile number to the service staff in order to earn i-dollars. Earning of i-dollars must be made at the point of transaction. Requests on i-dollar accumulation for previous or backdated receipts will not be entertained. The system may require up to one (01) working day to reflect the transactions, e-vouchers and i-dollar earned. I-dollars accrued shall expire upon expiry of the membership. Any i-dollar accrued is however granted a three (03) months grace period and must be converted to e-vouchers within this grace period, failing which such i-dollar shall be deemed forfeited. Transactions made via third party vendors are not eligible for earning of i-dollars.",
    membership_1_3_1_4: "Earned i-dollars are converted in the Member Portal into Imperial Treasure e-vouchers of a specified value (“e-vouchers”) at the rate specified on the membership programme website [https://members.imperialtreasure.com/] for the country in which you signed up. Each e-voucher is valid for twelve (12) months from date of issue and valid for use within the membership period only. The e-voucher can be used to offset the bill when dining at any participating Imperial Treasure restaurants, subject to Imperial Treasure’s sole discretion and any other terms and conditions stated at [https://members.imperialtreasure.co.jp]. Neither i-dollars nor e-vouchers have any cash value and cannot be converted or redeemed for cash.",
    membership_1_3_2: "1.3.2 Membership Tiers",
    membership_1_3_2_1: "Unless otherwise determined by Imperial Treasure in its sole discretion, Silver Tier status is conferred on Members when they first join the membership programme and is valid for the period specified on the membership programme website [https://members.imperialtreasure.co.jp] for the country in which you signed up. At the end of this period, if the Member has not been upgraded to the Gold Tier or Diamond Tier, the Member may be required to pay such renewal fee as may be prescribed by Imperial Treasure in its sole discretion on the membership website [https://members.imperialtreasure.co.jp] for the country in which you signed up. ",
    membership_1_3_2_2: "Gold Tier status is conferred on Members who spend at least the amount set out for Gold Tier on the membership programme website [https://members.imperialtreasure.com/] for the country in which you signed up, at participating Imperial Treasure restaurants within twelve (12) months. Gold Tier status is valid for twelve (12) months from the date the Member qualifies; after that, annual requalification is required. Upon expiration of your membership tenure as a Gold Tier member, and if you have not met the minimum spend requirement to be retained in the tier, you shall be downgraded to Silver Tier status.",
    membership_1_3_2_3: "Diamond Tier status is conferred on Members who spend at least the amount set out for Diamond Tier on the membership programme website [https://members.imperialtreasure.co.jp] for the country in which you signed up, at participating Imperial Treasure restaurants within twelve (12) months. Diamond Tier status is valid for twelve (12) months from the date the Member qualifies; after that, annual requalification is required. Upon expiration of your membership tenure as a Diamond Tier member, and if you have not met the minimum spend requirement to be retained in the tier, you shall be downgraded to Gold Tier or Silver Tier status accordingly.",
    membership_1_3_2_4: "Imperial Treasure may, in its sole discretion, alter, limit, or modify the Silver Tier, Gold Tier and/or Diamond Tier programme rules, regulations, benefits, eligibility for membership, or any other feature of the Silver Tier, Gold Tier and/or Diamond Tier programme and/or may terminate the Silver Tier, Gold Tier and/or Diamond Tier programme at any time in its sole discretion, by giving reasonable notice on the membership programme website and/or by email. Please check the membership programme website regularly for updates. ",
    membership_1_3_3: "1.3.3 Membership Tier Rewards",
    membership_1_3_3_1: "Each membership tier also entitles Members to certain rewards and privileges, which may include other e-vouchers, free gifts and/or other dining benefits (“Rewards”). The current tier privileges are as set out in the membership programme website [https://members.imperialtreasure.co.jp]. The validity and terms and conditions of such Rewards are as set out in [https://members.imperialtreasure.com/], which may be amended by Imperial Treasure at any time in its sole discretion, by giving reasonable notice on the membership programme website and/or by email. Rewards are always subject to availability. Imperial Treasure reserves the right to replace a Reward with another Reward of equivalent or similar value. Rewards do not have any cash value and cannot be converted or redeemed for cash.",
    membership_1_3_4: "1.3.4 Redemption of Rewards and e-vouchers",
    membership_1_3_4_1: "Member must be physically present (proof of identification required) at the point of dining to redeem any membership privileges. Member is required to sign off on the receipt to acknowledge the redemption(s) made. Redemption of Rewards are subject to prevailing local law requirements.",
    membership_1_3_4_2: "Combining multiple membership accounts, combining bills or splitting the bills to earn i-dollars and/or redeem Rewards and membership privileges is strictly not allowed. Membership must be active at the point of redemption.",
    membership_1_4: "1.4 Amending personal data and terminating membership",
    membership_1_4_1: `You may amend your personal data or marketing preferences at any time via https://members.imperialtreasure.co.jp  (the "Member's Portal"). You will need to inform us in writing at jp.club@imperialtreasure.com should you choose to terminate your membership. Please allow a few working days for changes to take effect. Kindly be advised that there will be no refunds made and/or early issuance of any unused e-vouchers at the point of termination. Alternatively, your membership will automatically expire upon non-renewal of membership, and all balance i-dollars and/or unused e-vouchers will be deemed forfeited`,
    membership_1_5: "1.5 Termination and cancellation",
    membership_1_5_1: "We reserve the right to terminate the Member's membership if the membership account is found to be shared with another non-Member.",
    membership_1_5_2: "We reserve the right to terminate your membership, in our absolute discretion, should you abuse any of the conditions and privileges bestowed on you as a Member.",
    membership_2: "2. Law and forum",
    membership_2_1: `These Membership Terms, including all policies and additional terms referenced herein (this "Membership Agreement"), are governed by, and construed in accordance with the laws of Singapore. Any dispute or claim arising out of or in connection with this Membership Agreement (including non-contractual disputes or claims) shall be subject to the non-exclusive jurisdiction of Singapore courts.`,
    membership_2_2: "If you are a consumer, you will benefit from any mandatory provisions of the laws of the country in which you are habitually resident. Nothing in this Membership Agreement affects your rights as a consumer to rely on such mandatory provisions of local law.",
    membership_3: "3. Consent",
    membership_3_1: "I would like to join the Imperial Treasure Membership Club and I consent to the collection, holding, use and disclosure of my personal data in accordance with your Privacy Notice. If I provide Imperial Treasure with any personal data relating to a third party, by submitting such information, I represent and warrant that I have obtained the consent of the third party for Imperial Treasure to collect, use and disclose their personal data in accordance with this Privacy Notice.",
    privacy: "Privacy Notice",
    privacy_1: "1. INTRODUCTION",
    privacy_1_1: 'Imperial Treasure Restaurant Group Pte Ltd, Imperial Treasure Cantonese Cuisine Pte Ltd, Imperial Treasure Noodle House Pte Ltd, Imperial Treasure Fine Dining Restaurant Pte Ltd, Multirich F&B Management Pte Ltd, Imperial Treasure Windows of Hong Kong Pte Ltd and Imperial Treasure Steamboat Pte Ltd (collectively referred as "Imperial Treasure", "us", "we") is committed to protecting the privacy of visitors to this website and our mobile application (the "Website"). This Privacy Notice sets out how Imperial Treasure collects, uses or discloses personal data that you have provided to us through the Website. By visiting the Website, you are accepting and consenting to the collection, use and disclosure of personal data described in this Privacy Notice. If you do not agree with this Privacy Notice, please do not use the Website. This Privacy Notice does not apply to other websites to which we link ("Third Party Website" or "Third Party Websites"). ',
    privacy_1_2: "This Privacy Notice also describes your data protection rights, including a right to object to some of the processing which Imperial Treasure carries out. More information about your rights, and how to exercise them, is set out in the following section: “8. What rights do I have”.",
    privacy_1_3: 'Maintaining the privacy of our customers’ information is important to us. We do not disclose rent or sell our customers’ personal data to third parties (except as described in "5. Disclosures of personal data to third parties").',
    privacy_1_4: "Imperial Treasure Restaurant Group Pte Ltd (https://www.imperialtreasure.com/contact) is responsible for sharing personal data among Imperial Treasure in accordance with this Privacy Notice.",
    privacy_2: "2. COLLECTION AND USE OF PERSONAL DATA",
    privacy_2_1: "We collect the following personal data when you register as a user of the Website and make purchases through the Website:",
    privacy_2_1_1: "email address",
    privacy_2_1_2: "your name, address and phone number (including delivery addresses if different);",
    privacy_2_1_3: "billing address, including your name, address and phone number; and",
    privacy_2_1_4: "any other personal data provided to us when you submit any comment, question or feedback to us, request services from us, or disclose your personal data to us in any way.",
    privacy_2_2: "We may collect, use and disclose your personal data for the following purposes:",
    privacy_2_2_1: "To fulfil a contract, or take steps linked to a contract: this is relevant where you make a purchase from us. This includes to:",
    privacy_2_2_1_1: "fulfil your order and deliver it to you;",
    privacy_2_2_1_2: "facilitate and track your purchases from us (including in our restaurants or via our websites); and",
    privacy_2_2_1_3: "provide you with service support.",
    privacy_2_2_2: "As required by Imperial Treasure to conduct our business and pursue our legitimate interest, in particular:",
    privacy_2_2_2_1: "to facilitate your registration as a user of the Website;",
    privacy_2_2_2_2: "to use information you provide to provide products and services you have requested;",
    privacy_2_2_2_3: "(if you use a card payment for any purchase on the Website) we use third parties to check the validity of the sort code, account number and card number you submit in order to prevent fraud; and;",
    privacy_2_2_2_4: "to respond to comments, queries and feedback.",
    privacy_2_2_3: "Where you give us consent:",
    privacy_2_2_3_1: "we provide you with marketing and promotional material and other information about our products (including promotions and special offers), as well as other products and services provided by our affiliates and partners; and",
    privacy_2_2_3_2: "on other occasions where we ask you for consent, we will use the personal data for the purposes which we explain at that time.",
    privacy_2_2_4: "For purposes which are required by law: to comply with legal and regulatory obligations, carry out internal audits or investigations, prevent fraud or other unlawful activities, or ensure the safety and security of you and us.",
    privacy_2_2_5: "For purposes that are reasonably necessary or ancillary to the abovementioned purposes.",
    privacy_2_2_6: "For any other purposes which we may have notified you prior to, or at the time of, obtaining your consent.",
    privacy_2_3: "The provision of your name, family name, contact number, gender, date of birth, country code and email address are mandatory so that we can contact you and fulfil any of your order(s): if any required data is not provided, then we will not be able to fulfil your order(s). All other provision of your information is optional.",
    privacy_2_4: "Additionally, through the Website, we may gather certain aggregated and anonymous information about the use of the Website, such as how frequently certain areas of the Website are visited, including through the use of cookies, web beacons, Google Analytics and other technologies.",
    privacy_2_5: "We may use cookies, web beacons, Google Analytics and other technologies for the following purposes:",
    privacy_2_5_1: "to identify the causes of problems arising at web servers and to resolve these problems;",
    privacy_2_5_2: "to improve the contents of the Website;",
    privacy_2_5_3: "to customize the content of the Website and our emails to suit your individual interests or purposes and selectively display best-matched pages to you, including tracking your past purchases in order to provide you with new services or special promotions;",
    privacy_2_5_4: "to utilize your browsing history on the Website for demographic research; and",
    privacy_2_5_5: "to obtain statistic data of web visitors and aggregated website visitation statistics which are anonymous in nature.",
    privacy_2_6: "You may reject our use of cookies by configuring your browser to disable the use of cookies. However, you may no longer be able to receive services or personalized features of the Website which rely on the use of cookies.",
    privacy_2_7: "For information about the data gathered by Google in connection with Google Analytics, please see the relevant policy provided by Google at ([GA4] Data collection - Analytics Help",
    privacy_3: "3. SENDING OF EMAILS TO MEMBERS",
    privacy_3_1: "Genuine emails from Imperial Treasure always will come from an address ending @imperialtreasure.com. Do not open any attachments or click any links from suspicious emails. If you wish to report a suspicious email claiming to be from Imperial Treasure that you believe is a forgery, you may email to jp.marketing@imperialtreasure.com",
    privacy_4: "4. WITHDRAWING CONSENT OR OTHERWISE OBJECTING TO DIRECT MARKETING",
    privacy_4_1: "Wherever we rely on your consent, you will always be able to withdraw that consent, although we may have other legal grounds for processing your personal data for other purposes, such as those set out above. You have an absolute right to opt-out of direct marketing, or profiling we carry out for direct marketing, at any time. You can do this by following the instructions in the communication where it is an electronic message, or by contacting us using the details set out below.",
    privacy_4_2: 'Where you have provided us with your consent, Imperial Treasure, our affiliates, related entities, and third parties acting on our behalf ("Business Partners"), may collect, use and disclose your personal data, which you have provided at the Member\'s Portal, for providing marketing material that you have agreed to receive, in accordance with the Personal Data Protection Act 2012 and our Privacy Notice. Please note that marketing material may be sent directly by our Business Partners, and we may disclose your personal data to them for that purpose.',
    privacy_5: "5. DISCLOSURES OF PERSONAL DATA TO THIRD PARTIES",
    privacy_5_1: "In order to provide services to you and for the purposes listed at “2 Collection and Use of Personal Data” above, we may disclose and/or transfer your personal data out of Singapore, as described in this Privacy Notice:",
    privacy_5_1_1: "We may share your personal data with our affiliated companies for the purposes of fulfilling a contract with you, providing customer services and membership services, and facilitating your registration as a user of the Website:",
    privacy_5_1_2: "We may permit certain trusted third parties to access your personal data in connection with their performance of services to maintain and operate the Website and certain features on the Website. For example, we may use third parties to host the Website; operate various features available on the Website; send emails; analyze data; provide search results and links and assist in fulfilling your orders and may share personal data or other information with our parent, subsidiaries, divisions, and affiliates.",
    privacy_5_1_3: "We may employ a third-party service to collect the above-mentioned information, including personal data, and use their tracking services on our behalf. However, this information is strictly confidential and will not be shared with others.",
    privacy_5_1_4: "We may disclose personal data as an asset in connection with a proposed or actual merger or sale (including any disclosures made as part of an insolvency or bankruptcy proceeding) involving all or part of our business or as part of a corporate reorganization, stock sale or other change in control.",
    privacy_5_1_5: "We reserve the right to disclose information, including personal data, in order to comply with a subpoena, court order, administrative or governmental order, or any other requirement of law, or when we, in our sole discretion, believe it is necessary in order to protect our rights or the rights of others, to prevent harm to persons or property, to fight fraud and credit risk reduction. We may also disclose or transfer personal data as otherwise permitted or required by law; and",
    privacy_5_1_6: "We may disclose aggregated and anonymized data to third parties.",
    privacy_5_2: "Your personal data may be transferred out of Singapore from time to time. Such transfers will be carried out in accordance with the Singapore Personal Data Protection Act 2012.",
    privacy_6: "6. HOW WE PROTECT YOUR INFORMATION",
    privacy_6_1: "We are committed to protecting the information we receive from you. We adopt reasonable physical, technical and administrative practices to help protect the confidentiality, security and integrity of data, including personal data, stored on our system. We believe the measures we have implemented reduce the likelihood of security problems to a level appropriate to the type of data involved. Although we take reasonable steps to protect the information we receive from you, no computer system is completely secure, and we cannot be held liable for any loss you may suffer for unauthorized access or loss of any data provided to the Website, unless such loss is due to our willful misconduct or gross negligence.",
    privacy_7: "7. LINKS TO THIRD PARTY SITES",
    privacy_7_1: "The Website may contain links to third party websites and microsites, including third party payment gateways, whose privacy practices may differ from those of ours. If you submit personal data, including payment information, to any of those websites, that personal data is not subject to this Privacy Notice and will be subject to the third party's privacy practices instead.",
    privacy_7_2: "We therefore encourage you to review the privacy statement of any website you visit. By clicking on or activating such links and leaving the Website, we can no longer exercise control over any data or information which you give to any other entity after leaving the Website, and any access to such other websites is entirely at your own risk.",
    privacy_8: "8. WHAT RIGHTS DO I HAVE",
    privacy_8_1: "You have the right to ask us for a copy of your personal data; to access or correct; and to obtain the personal data you provide to us for a contract or with your consent in a structured, machine readable format, and to ask us to share (port) this data to another data controller.",
    privacy_8_2: "These rights may be limited, for example if fulfilling your request would reveal personal data about another person or where they would infringe the rights of a third party (including our rights). Relevant exemptions are included in the applicable laws and regulations. We will inform you of relevant exemptions we rely upon when responding to any request you make.",
    privacy_8_3: "To exercise any of these rights, or to obtain other information, such as a copy of a legitimate interests balancing test, you can get in touch with us – by contacting our Data.",
    privacy_8_4: 'Protection Officer (See "11. Contact us" below). To access and correct your personal data, you can do so by signing into your user account and updating your personal data. We will only disclose personal data in accordance with an access request to the individual who registered his/her personal data with the Website, and only after confirming that the person requesting access is indeed the registered party.',
    privacy_8_5: "You may also contact our Data Protection Officer to withdraw your consent to our use of your personal data.",
    privacy_8_6: "Please allow thirty (30) days for your request to be processed.",
    privacy_9: "9. RETENTION OF INFORMATION",
    privacy_9_1: "Where we process registration data, we do this for as long as you are an active user of the Website and for six (6) years after this.",
    privacy_9_2: "Where we process personal data for marketing purposes or with your consent, we will process such data until you ask us to stop and for a short period after this (to allow us to implement your requests). We also keep a record of the fact that you have asked us not to send you direct marketing or not to process your data so that we can respect your request in the future.",
    privacy_9_3: "Where we process personal data in connection with performing a contract, we keep such data for six (6) years from your last interaction with us",
    privacy_9_4: "If you withdraw your consent to our collection, use or disclosure of your personal data, we may not be able to provide you with services that require such personal data. Please also note that your personal data may still be retained on our database to the extent permitted by law.",
    privacy_10: "10. PRIVACY NOTICE CHANGES",
    privacy_10_1: "If we decide to change our Privacy Notice for the Website, we will post the revised Privacy Notice here and, if appropriate, notify you by email. Please check back frequently to see any updates or changes to our Privacy Notice.",
    privacy_11: "11. CONTACT US",
    privacy_11_1: "If you have any questions about this Privacy Notice, please contact our Data Protection Officer at DPO@imperialtreasure.com.",
  },
  outlets: {
    outlets: "餐廳",
    restaurant_name: "餐廳名稱",
    address: "住址",
    contact: "聯繫",
    email: "電郵地址",
    outlets_1_1: "御宝軒",
    outlets_1_2: "東京都中央区",
    outlets_1_3: "銀座3-5-4 GAREN 12樓",
    outlets_1_4: "+81 3-62286848",
    outlets_1_5: "finechinese_ginza@imperialtreasure.com",

    outlets_2_1: "御宝至尊烤鴨店",
    outlets_2_2: "百利宮, #05-42,",
    outlets_2_3: "烏節路 290號, 新加坡 238859",
    outlets_2_4: "(+65) 6732 7838",
    outlets_2_5: "paragon@imperialtreasure.com",

    outlets_3_1: "御宝至尊烤鴨店",
    outlets_3_2: "亞洲廣場 1座, #02-08,",
    outlets_3_3: "濱海景 8號, 新加坡 018960",
    outlets_3_4: "(+65) 6636 1868",
    outlets_3_5: "asq@imperialtreasure.com",

    outlets_4_1: "御宝閣潮州酒家",
    outlets_4_2: "愛雍·烏節, #03-05,",
    outlets_4_3: "烏節路, 新加坡 238801",
    outlets_4_4: "(+65) 6736 2118",
    outlets_4_5: "fineteochew_ion@imperialtreasure.com",

    outlets_5_1: "御宝閣潮州酒家",
    outlets_5_2: "濱海灣金沙, 1 樓海灣區, #01-26,",
    outlets_5_3: "海灣舫道 2號, 新加坡 018972",
    outlets_5_4: "(+65) 6688 7333",
    outlets_5_5: "fineteochew_mbs@imperialtreasure.com",

    outlets_6_1: "禦園",
    outlets_6_2: "高島屋購物中心, #04-22,",
    outlets_6_3: "烏節路 391號, 新加坡 238872",
    outlets_6_4: "(+65) 6836 6909",
    outlets_6_5: "sh_nac4@imperialtreasure.com",

    outlets_7_1: "御宝軒",
    outlets_7_2: "大世界, #02-111,",
    outlets_7_3: "金聲路, 新加坡 237994",
    outlets_7_4: "(+65) 6732 2232",
    outlets_7_5: "cc_gwc@imperialtreasure.com",

    outlets_8_1: "Imperial Treasure Bar + Grill",
    outlets_8_2: "暫時停止營業",
    outlets_8_3: "大世界, #02-111,",
    outlets_8_4: "金聲路, 新加坡 237994",
    outlets_8_5: "(By Reservation only)",
    outlets_8_6: "(+65) 6733 2292",
    outlets_8_7: "bar_grill_gw@imperialtreasure.com",

    outlets_9_1: "御宝火鍋店",
    outlets_9_2: "愛雍·烏節, #04-12A,",
    outlets_9_3: "烏節路, 新加坡 238801",
    outlets_9_4: "(+65) 6636 9339",
    outlets_9_5: "ion_steamboat@imperialtreasure.com",

    outlets_10_1: "御宝火鍋店",
    outlets_10_2: "大世界, #01-140,",
    outlets_10_3: "金聲路, 新加坡 237994",
    outlets_10_4: "(+65) 6235 6008",
    outlets_10_5: "steamboat_gwc@imperialtreasure.com",

    outlets_11_1: "御宝火鍋店",
    outlets_11_2: "111 索美賽, #02-14,",
    outlets_11_3: "111索美賽路, 新加坡 238164",
    outlets_11_4: "(+65) 6235 3882",
    outlets_11_5: "steamboat_111@imperialtreasure.com",

    outlets_12_1: "寶一點心",
    outlets_12_2: "百利宮, #B1-08,",
    outlets_12_3: "烏節路 290號, 新加坡 238859",
    outlets_12_4: "(+65) 6262 3662",
    outlets_12_5: "paragon_ydx@imperialtreasure.com",

    outlets_13_1: "寶一點心",
    outlets_13_2: "百匯廣場, #02-14,",
    outlets_13_3: "馬林百列路, 新加坡 449269",
    outlets_13_4: "(+65) 6247 9218",
    outlets_13_5: "parkway_ydx@imperialtreasure.com",

    outlets_14_1: "寶一點心",
    outlets_14_2: "來福士城, #B1-37,",
    outlets_14_3: "北橋路 252號, 新加坡 179103",
    outlets_14_4: "(+65) 6262 1662",
    outlets_14_5: "rafflescity_ydx@imperialtreasure.com",

    outlets_15_1: "御宝至尊烤鴨店",
    outlets_15_2: "星耀樟宜機場, #01-219,",
    outlets_15_3: "機場大道78號, 新加坡 819666",
    outlets_15_4: "(+65) 6908 6689",
    outlets_15_5: "spd_jewel@imperialtreasure.com",

    outlets_16_1: "寶一點心",
    outlets_16_2: "星耀樟宜機場, #01-221,",
    outlets_16_3: "機場大道78號, 新加坡 819666",
    outlets_16_4: "(+65) 6908 3668",
    outlets_16_5: "jewel_ydx@imperialtreasure.com",

    outlets_17_1: "御宝淮揚料理",
    outlets_17_2: "愛雍·烏節 , #04-12A,",
    outlets_17_3: "烏節路, 新加坡 238801",
    outlets_17_4: "(+65) 6636 9339",
    outlets_17_5: "huaiyang_ion@imperialtreasure.com",
  },
  privilege: {
    title: "會員禮遇",
    privilege: "會員禮遇",
    privelege_txt: "凡在国内外餐廳每消費1,000円*，即可賺取 i$1 ",
    privelege_txt2: "累計 i$50 即可獲得¥5,000電子禮券,可於參與的本地餐廳使用",
    silver: "銀",
    silver_signup: "僅限邀請",
    silver_1: "",
    silver_2: "",
    silver_3: "",
    silver_renewal: "",
    silver_4: "",
    silver_5: "",
    silver_6: "",
    gold: "金",
    gold_1: "當您在會員資格年度內累積消費滿130萬円*以上, 將會升級成為金會員",
    gold_2: "贈送禮品:",
    gold_3: "1 隻北京式烤鴨 ",
    gold_4: "1 瓶酒",
    gold_5: "",
    gold_6: "",
    gold_7: "",
    diamond: "鑽石",
    diamond_1: "當您在會員資格年度內累積消費滿330萬円*以上，將會升級成為鑽石會員",
    diamond_2: "享有金會員*禮遇以及免費贈送:",
    diamond_3: "1 張5萬円的電子獎勵禮券",
    diamond_4: "1 瓶香檳 ",
    diamond_5: "",
    remarks: "*不包括促銷品，服務費，消費稅，電子禮券兌換，購買或使用御宝禮券和季節食品 \n^每位會員在每個會員週期內僅可獲得一 (01) 套金會員禮遇",
    sign_up_now: "立即註冊",
  },
  resetPassword: {
    title: "忘記密碼",
    reset_password: "重置密碼",
    email: "*請輸入電郵地址",
    email_input: "請輸入電郵地址",
    email_errMsg: "請輸入有效的電郵地址",
    mobile: "*請輸入手機號碼",
    mobile_errMsg: "請輸入有效電話號碼",
    new_password: "*新密碼",
    new_password_errMsg1: "請輸入密碼",
    new_password_errMsg2: "密碼至少為8個字符，其中需包含大小字母、數字和一個特殊字符 (?!@$%&*)",
    confirm_password: "*確認新密碼",
    confirm_password_errMsg: "請確認密碼",
    reset_password2: "前去重置密碼",
    has_been_reset: "密碼已重置！",
    login: "登錄",
  },
  forgetPassword: {
    title: "忘記密碼",
    reset_password: "重置密碼",
    forgot_password: "忘記密碼？",
    reset_pw_method: "請選擇密碼重置方式",
    by_mobile: "通過手機",
    by_email: "透過電郵地址",
    email: "*請輸入電郵地址",
    email_input: "請輸入電郵地址",
    email_errMsg: "請輸入有效的電郵地址",
    mobile: "*請輸入手機號碼",
    mobile_errMsg: "請輸入有效電話號碼",
    reset_password2: "前去重置密碼",
    reset_password_sent_email: "重設密碼連結已發送至您的電子郵件。",
    reset_password_sent_mobile: "重設密碼連結已發送至您的手機。",
    next: "下一步",
    back: "上一步",
  },
  updateEmail: {
    title: "更新電郵地址",
    member_profile: "會員檔案",
    updateEmail: "更新電郵地址",
    new_email: "*新電郵地址",
    sent: "發送",
    send_token: "發送驗證碼",
    email_errMsg1: "請輸入有效電子郵件",
    email_errMsg2: "電郵地址已註冊",
    token: "*驗證碼",
    token_error: "驗證碼錯誤",
    update: "更新",
    update_success: "更新成功！",
    done: "完成",
    Msg1: "手機和電郵地址都已使用",
    Msg2: "電郵地址已使用",
  },
  updateMobile: {
    title: "修改手機號碼",
    member_profile: "會員檔案",
    updateMobile: "修改手機號碼",
    new_mobile: "*新手機號碼",
    sent: "發送",
    send_token: "發送驗證碼",
    mobile_errMsg1: "請輸入有效手機號碼",
    mobile_errMsg2: "手機號碼已註冊",
    token: "*驗證碼",
    token_error: "驗證碼錯誤",
    update: "更新",
    update_success: "更新成功！",
    done: "完成",
    Msg1: "手機和電郵地址都已使用",
    Msg2: "電郵地址已使用",
  },
  coupon: {
    title: "禮券",
    member_profile: "會員檔案",
    coupon: "禮券",
    birthdayNote: "您的生日電子禮券只會在您的生日月份內顯示。",
    active: "有效的",
    redeemed: "已兌換",
    expired: "過期",
    type_of_vouchers_opt1: "請選擇禮券類型",
    type_of_vouchers_opt2: "類型A",
    type_of_vouchers_opt3: "類型B",
    type_of_vouchers_opt4: "類型C",
    type_of_vouchers_opt5: "類型D",
    expiry_date: "到期日期：",
    redeemed_store: "贖回商店：",
    vaild_date: "有效日期",
    description: "說明",
    vouchers_code: "禮券代碼",
    done: "完成",
    no_coupon_msg: "沒有可用的禮券",
    previous: "上一頁",
    next: "下一頁"
  },
  editProfile: {
    title: "編輯個人資料",
    member_profile: "會員檔案",
    editProfile: "編輯個人資料",
    general: "帳戶資料",
    security: "安全資訊",
    subscriptions: "資訊訂閱",
    salutation: "*稱謂",
    salutation_opt1: "請選擇您的稱謂",
    salutation_opt2: "先生",
    salutation_opt3: "太太",
    salutation_opt4: "女士",
    salutation_opt5: "小姐",
    salutation_opt6: "博士",
    salutation_errMsg: "請選擇稱謂",
    gender: "*性別",
    gender_opt1: "請選擇您的性別",
    gender_opt2: "男性",
    gender_opt3: "女性",
    gender_errMsg: "請選擇性別",
    first_name: "*名字",
    first_name_errMsg: "請輸入名字",
    last_name: "*姓氏",
    last_name_errMsg: "請輸入姓氏",
    birth: "*出生日期",
    mobile: "*手機號碼",
    mobile_change: "修改",
    email: "*電郵地址",
    email_change: "修改",
    language: "*語言選項",
    language_opt1: "請選擇您的語言選項",
    language_opt2: "English",
    language_opt3: "日本語",
    language_opt4: "中文",
    update: "更新",
    previous_password: "*舊密碼",
    previous_password_errMsg: "舊密碼密碼不正確",
    new_password: "*新密碼",
    new_password_errMsg1: "請輸入密碼",
    new_password_errMsg2: "密碼至少為8個字符，其中需包含大小字母、數字和一個特殊字符 (?!@$%&*)",
    confirm_password: "*確認密碼",
    confirm_password_errMsg: "請確認密碼",
    subscriptions_txt1: "通過勾選以下的方框，我同意御宝餐飲集團有限公司及其子公司（“ITRG”）收集、使用、儲存或披露與我的御宝會員身份相關的個人資訊（“個人資訊”），根據<link>隱私權聲明<link>，以便ITRG將我的個人資訊共用至其附屬公司、關聯公司或其他協力廠商，從而使我能夠享受御宝俱樂部會員資格的權益，包括源於ITRG與新加坡內外服務提供者之間關係而產生的權益。",
    subscriptions_txt2: "我希望收到來自ITRG的行銷/推廣資訊與材料。",
    by_email: "透過電郵地址",
    by_mobile: "透過電話",
    update_success: "更新成功！",
    done: "完成",
    password_update_success: "密碼修改成功！",
  },
  profile: {
    title: "會員",
    logout: "登出",
    click_to_renew: "點擊更新",
    activation_now: "立即啟用",
    menber_id: "會員號碼:",
    member: "會員",
    active: "有效的",
    expired: "過期",
    salutation: "稱謂：",
    mobile: "手機號碼：",
    birth: "出生日期：",
    password: "密碼：",
    ellipsis: "········",
    change: "更改",
    gender: "性別：",
    email: "電郵地址：",
    cycle_start_date: "等級開始日期：",
    first_joined_date: "首次加入日期：",
    optin_email: "選擇電郵地址：",
    optin_sms: "選擇短信：",
    cycle_expiry_date: "週期到期日：",
    language_preference: "語言選項：",
    spend: "消費円",
    expires_on: " 截止日期",
    spend_required: "還需淨消費",
    to_upgrade_to: "升級為",
    diamond_membership: "鑽石卡會員",
    nett_spend_required: "維持所需的淨消費",
    nett: "淨值",
    to_maintain_to: "維持",
    silver_member: "銀卡會員",
    gold_member: "金卡會員",
    diamond_member: "鑽石卡會員",
    total_nett_spend: "總淨消費金額",
    current_membership: "在當前會員年份*",
    i_dollar: "i-Dollar",
    last_update: " 最新一次更新：",
    i_dollar_earned: "賺取的 i-Dollar",
    i_dollar_converted: "已兌換的 i-Dollar",
    i_dollar_balance: "剩餘的 i-Dollar",
    i_dollar_automatically: "50 i-dollars 將自動轉換為價值 5,000 円的電子禮券",
    total_earned_converted: "已賺取及兌換的 i$",
    i_dollar_available: "剩餘的 i$\n（尚未轉換為電子禮券）",
    i_dollar_automatically2: "我們會自動將 i$50 轉換為 5,000 円電子禮券。\n您的 i$ 依然安全，現已轉為電子禮券。",
    vouchers: "現金券",
    currently_active: "目前有效",
    cash_vouchers: "現金劵",
    food_vouchers: "食品/促銷券",
    click_to_view: "點擊查看",
    transaction: "交易",
    this_month: "本月",
    last_3_months: "過去 3 個月",
    last_12_months: "過去12個月",
    transaction_details: "交易明細",
    transaction_date: "交易日期",
    transaction_time: "交易時間",
    outlet: "餐廳",
    receipt: "單據編碼",
    payment_method: "付款方式",
    receipt_details: "收據詳情",
    zero: ".0000",
    i_dollars_eared: "i-DOLLARS 賺取:",
    total: "總額：",
    done: "完成",
    thankyou_msg: "感謝您與我們一起用餐！",
    activate_membership: "啟用會員資格",
    activate_membership_1: "只需 20 新元即可啟用您的會員身份享受以下禮遇*：",
    activate_membership_2: "每消費 10 新元，即可賺取 i$1。累積 i$50 可兌換 50 新元電子禮券",
    activate_membership_3: "1 張 50 新元更新電子禮券 (有效期為 3 個月)",
    activate_membership_4: "1 張 100 新元生日電子禮券（僅限生日當月，且單筆有效消費滿 280 新元時可使用）",
    activate_membership_5: "3 張 30新元火鍋湯底 (有效期為 12 個月)",
    activate_membership_7: "率先收到最新資訊和私人活動專屬邀請！",
    renew_membership: "更新會員資格",
    renew_membership_1: "只需 20 新元即可更新您的會員身份享受以下禮遇*：",
    renew_membership_2: "每消費 10 新元，即可賺取 i$1。累積 i$50 可兌換 50 新元電子禮券",
    renew_membership_3: "1 張 50 新元更新電子禮券 (有效期為 3 個月)",
    renew_membership_4: "1 張 100 新元生日電子禮券（僅限生日當月，且單筆有效消費滿 280 新元時可使用）",
    renew_membership_5: "3 張 30新元火鍋湯底 (有效期為 12 個月)",
    renew_membership_6: "率先收到最新資訊和私人活動專屬邀請！",
    confirm_to_renew: "確認續訂",
    confirm_to_activate: "確認啟用",
    change_password: "修改密碼",
    previous_password: "*舊密碼",
    previous_password_errMsg: "舊密碼不正確",
    new_password: "*新密碼",
    new_password_errMsg1: "請輸入並確認密碼",
    new_password_errMsg2: "密碼至少為8個字符，其中需包含大小字母、數字和一個特殊字符 (?!@$%&*)​",
    confirm_password: "*確認密碼",
    close: "X 關閉",
    member_activated: "會員已啟用",
    password_updated: "密碼已更新",
    friend_referral: "推薦朋友",
    view_more: "查看更多",
    add_friend: "添加",
    silver_tier: "銀卡",
    gold_tier: "金卡",
    diamond_tier: "鑽石卡",
    spend_date_format: "年過期",
  },
  friendReferral: {
    title: "推薦朋友",
    note1: "推薦成功後，推薦人將獲得 S$10 電子禮券。",
    note2: "此外，被推薦註冊的會員將獲得額外的電子優惠券，以 S$78 （原價 S$178）的價格購買招牌北京烤鴨。",
    email: "電郵地址",
    referee_email: "推薦朋友電郵地址",
    emailAddress_errMsg: "請輸入有效的電郵地址",
    mobile: "電話號碼",
    referee_mobile: "推薦朋友電話號碼",
    mobile_errMsg: "請輸入有效的電話號碼",
    mobile_errMsg2: "手機號碼已註冊",
    name: "姓名",
    referee_name: "推薦朋友姓名",
    name_errMsg: "請輸入推薦朋友姓名",
    referral_sucMsg: "你已成功推薦朋友!",
    referral_errMsg: "推薦朋友已為現有御宝註冊會員。",
    submit: "立即推薦",
    tnc: "附帶條款"
  },
  transactionDetails: {
    transaction_date: "交易日期",
    outlet: "餐廳",
    receipt_no: "單據編碼",
    amount_spend: "消費金額",
    amount_qualified_for_i_dollar: "符合 i-Dollar 金額",
    i_dollars: "i-Dollars",
    selected_start_date: "選定開始日期",
    selected_end_date: "選定結束日期",
    no_tranMsg: "所選期間無交易記錄。",
    action: "行動",
    apply: "應用",
    view: "查看",
  },
  contactUs: {
    title: "聯絡我們",
    title_message: "請在以下填寫並提交您的回饋。我們將在 3-5 個工作天內與您聯繫。",
    firstname: "名字",
    firstname_errMsg: "請輸入您的名字",
    lastname: "姓氏",
    lastname_errMsg: "請輸入您的姓氏",
    emailAddress: "電郵地址",
    emailAddress_errMsg: "請輸入有效的電郵地址",
    mobile: "手機號碼",
    mobile_errMsg: "請輸入有效電話號碼",
    type: "類型",
    type_opt1: "請輸入您的回饋資訊類型 :",
    type_opt2: "聯絡我們",
    type_opt3: "查詢",
    type_opt4: "回饋",
    type_opt5: "電子報",
    type_errMsg: "請輸入您的回饋訊息",
    message: "訊息",
    message_errMsg: "請輸入您的回饋訊息",
    captcha: "驗證碼",
    captcha_errMsg: "驗證碼不正確",
    feedback_sucMsg: "非常感謝您與我們聯繫並提供寶貴的回饋。 \n請稍等我們回覆。",
    submit: "提交",
  },
  mobileApp: {
    title: "御宝手機應用程式",
    desc_1: "享美食，賺獎勵",
    desc_2: "立即下載御宝手機應用程式！"
  },
  languageSetting: {
    title: "語言設置",
    setting: "語言選項",
    language_preference: "語言選項",
    language_preference_opt1: "請選擇您的語言選項",
    language_preference_opt2: "English",
    language_preference_opt3: "日本語",
    language_preference_opt4: "中文",
    language_preference_errMsg: "請選擇語言選項",
    submit: "提交",
  },
  captcha: {
    title: "安全驗證",
    intro: "請輸入驗證碼（區分大小寫）",
    error: "驗證碼不正確",
    confirm: "確認"
  },
  otp: {
    sec: "秒",
    verification_code: "輸入驗證碼",
    send_code: "取得驗證碼",
    resend_code: "重新傳送驗證碼",
    success_sent_mobile: "驗證碼已傳送到您註冊的手機號碼。",
    success_sent_email: "驗證碼已傳送至您註冊的電子郵件信箱。",
    err_login: "請點選「取得驗證碼」按鈕以取得驗證碼。",
    err_verify: "您輸入的驗證碼無效。請使用發送給您的6位數驗證碼重試。",
    err_expired: "驗證碼已過期。請重新取得驗證碼。",
    incorrect_mobile: "您輸入的手機號碼不正確。",
    incorrect_email: "您輸入的電子郵件信箱不正確。",
    please_retry: "請在 3 分鐘後再獲取驗證碼。"
  }
};
